import { ContactState } from "../interfaces/contacts"
import { Types } from "../types"
import { ContactActions } from "../types/contacts/actionsType"

const initialState: ContactState = {

    getContactCallDirectPending: false,
    getContactCallDirectError: null,
    contactsCallDirect: {
        data: [],
        pageNumber: 0,
        pageSize: 0,
        totalCount: null
    },

    contactList: {
        data: [],
        pageNumber: 0,
        pageSize: 0,
        totalCount: null
    },
    contacts: {
        data: [],
        pageNumber: 0,
        pageSize: 0,
        totalCount: null
    },
    unpagedContacts: {
        data: [],
        pageNumber: 0,
        pageSize: 0,
        totalCount: null
    },
    getContactsPending: true,
    getContactsByPhonBookIdPending: false,
    contactListByPhoneBook: [],
    addContactPending: false,
    addContactSuccess: false,
    updateContactPending: false,
    updateContactSuccess: false,
    removeFromPhoneBookContactPending: false,
    removeFromPhoneBookContactSuccess: false,
    removeContactPending: false,
    removeContactSuccess: false,
    etContactCategoryPending: false,
    contactCategories: null,
    addContactCategoryPending: false,
    addContactCategorySuccess: false,
    updateContactCategoryPending: false,
    updateContactCategorySuccess: false,
    removeContactCategoryPending: false,
    removeContactCategorySuccess: false,

    getPhoneBooksPending: false,
    getPhoneBooksSuccess: false,
    phoneBooks: {
        data: [],
        pageNumber: 0,
        pageSize: 0,
        totalCount: null,
        fillData: function (list: any[]): void {
            throw new Error("Function not implemented.")
        }
    },
    getUnpagedPhonebookPending: false,
    getUnpagedPhonebookSuccess: false,
    unpagedPhonebook: {
        data: [],
        pageNumber: 0,
        pageSize: 0,
        totalCount: null,
        fillData: function (list: any[]): void {
            throw new Error("Function not implemented.")
        }
    },
    addPhoneBookPending: false,
    addPhoneBookSuccess: false,
    updatePhoneBookPending: false,
    updatePhoneBookSuccess: false,
    removePhoneBookPending: false,
    removePhoneBookSuccess: false,
    copyByPhonebookPending: false,
    copyByPhonebookSuccess: false,
    moveByPhonebookPending: false,
    moveByPhonebookSuccess: false,
    moveByContactPending: false,
    moveByContactSuccess: false,
    copyByContactPending: false,
    copyByContactSuccess: false,
    contactListToBlockPending: false,
    contactListToBlockSuccess: false,
    selectedContactCategory: null
}


const contactReducer = (state = initialState, action: ContactActions, response: any) => {

    switch (action.type) {
        case Types.GET_ALL_CONTACTS_REQUEST:
            return {
                ...state,
                getContactsPending: true,
                getContactsError: null,

            }
        case Types.GET_ALL_CONTACTS_SUCCESS:

            return {
                ...state,
                getContactsPending: false,
                getContactsError: null,
                contactList: action.response

            }

        case Types.GET_ALL_CONTACTS_ERROR:

            return {
                ...state,
                getContactsPending: false,
                getContactsError: action.payload
            }


        case Types.GET_CONTACT_REQUEST:
            return {
                ...state,
                getContactPending: true,
                getContactError: null,

            }
        case Types.GET_CONTACT_SUCCESS:

            return {
                ...state,
                getContactPending: false,
                getContactError: null,
                contacts: action.response

            }


        case Types.GET_CONTACT_ERROR:

            return {
                ...state,
                getContactPending: false,
                getContactError: action.payload
            }


        case Types.GET_UNPAGED_CONTACT_REQUEST:
            return {
                ...state,
                getUnpagedContactPending: true,
                getUnpagedContactError: null,

            }
        case Types.GET_UNPAGED_CONTACT_SUCCESS:

            return {
                ...state,
                getUnpagedContactPending: false,
                getUnpagedContactError: null,
                unpagedContacts: action.response

            }


        case Types.GET_UNPAGED_CONTACT_ERROR:

            return {
                ...state,
                getUnpagedContactPending: false,
                getUnpagedContactError: action.payload
            }


        case Types.GET_CONTACTS_BY_PHONE_BOOK_ID_REQUEST:
            return {
                ...state,
                getContactsByPhonBookIdPending: true,
                getContactsByPhonBookIdError: null,

            }
        case Types.GET_CONTACTS_BY_PHONE_BOOK_ID_SUCCESS:

            return {
                ...state,
                getContactsByPhonBookIdPending: false,
                getContactsByPhonBookIdError: null,
                contactListByPhoneBook: action.response

            }

        case Types.GET_CONTACTS_BY_PHONE_BOOK_ID_ERROR:

            return {
                ...state,
                getContactsByPhonBookIdPending: false,
                getContactsByPhonBookIdError: action.payload
            }

        case Types.ADD_CONTACT_REQUEST:
            return {
                ...state,
                addContactPending: true,
                addContactError: null,
                addContactSuccess: false,


            }
        case Types.ADD_CONTACT_SUCCESS:

            return {
                ...state,
                addContactPending: false,
                addContactSuccess: true,

            }

        case Types.ADD_CONTACT_ERROR:

            return {
                ...state,
                addContactPending: false,
                addContactError: action.payload
            }

        case Types.UPDATE_CONTACT_REQUEST:
            return {
                ...state,
                updateContactPending: true,
                updateContactSuccess: false,
                updateContactError: null,

            }
        case Types.UPDATE_CONTACT_SUCCESS:

            return {
                ...state,
                updateContactPending: false,
                updateContactSuccess: true,

            }

        case Types.UPDATE_CONTACT_ERROR:

            return {
                ...state,
                updateContactPending: false,
                updateContactError: action.payload
            }

        case Types.REMOVE_FROM_PHONE_BOOK_CONTACT_REQUEST:
            return {
                ...state,
                removeFromPhoneBookContactPending: true,
                removeFromPhoneBookContactSuccess: false,
                removeFromPhoneBookContactError: null,


            }
        case Types.REMOVE_FROM_PHONE_BOOK_CONTACT_SUCCESS:

            return {
                ...state,
                removeFromPhoneBookContactPending: false,
                removeFromPhoneBookContactSuccess: true,

            }

        case Types.REMOVE_FROM_PHONE_BOOK_CONTACT_ERROR:

            return {
                ...state,
                removeFromPhoneBookContactPending: false,
                removeFromPhoneBookContactError: action.payload
            }


        case Types.REMOVE_CONTACT_REQUEST:
            return {
                ...state,
                removeContactPending: true,
                removeContactSuccess: false,

                removeContactError: null,

            }
        case Types.REMOVE_CONTACT_SUCCESS:

            return {
                ...state,
                removeContactPending: false,
                removeContactSuccess: true,

            }

        case Types.REMOVE_CONTACT_ERROR:

            return {
                ...state,
                removeContactPending: false,
                removeContactError: action.payload
            }

        case Types.GET_CONTACT_CATEGORY_REQUEST:
            return {
                ...state,
                etContactCategoryPending: true,
                etContactCategoryError: null,

            }
        case Types.GET_CONTACT_CATEGORY_SUCCESS:

            return {
                ...state,
                etContactCategoryPending: false,
                contactCategories: action.response

            }

        case Types.GET_CONTACT_CATEGORY_ERROR:

            return {
                ...state,
                etContactCategoryPending: false,
                etContactCategoryError: action.payload
            }

        case Types.ADD_CONTACT_CATEGORY_REQUEST:
            return {
                ...state,
                addContactCategoryPending: true,
                addContactCategorySuccess: false,

                addContactCategoryError: null,

            }
        case Types.ADD_CONTACT_CATEGORY_SUCCESS:

            return {
                ...state,
                addContactCategoryPending: false,
                addContactCategorySuccess: true,

            }

        case Types.ADD_CONTACT_CATEGORY_ERROR:

            return {
                ...state,
                addContactCategoryPending: false,
                addContactCategoryError: action.payload
            }

        case Types.UPDATE_CONTACT_CATEGORY_REQUEST:
            return {
                ...state,
                updateContactCategoryPending: true,
                updateContactCategorySuccess: false,

                updateContactCategoryError: null,

            }
        case Types.UPDATE_CONTACT_CATEGORY_SUCCESS:

            return {
                ...state,
                updateContactCategoryPending: false,
                updateContactCategorySuccess: true,

            }

        case Types.UPDATE_CONTACT_CATEGORY_ERROR:

            return {
                ...state,
                updateContactCategoryPending: false,
                updateContactCategoryError: action.payload
            }



        case Types.REMOVE_CONTACT_CATEGORY_REQUEST:
            return {
                ...state,
                removeContactCategoryPending: true,
                removeContactCategorySuccess: false,
                removeContactCategoryError: null,

            }
        case Types.REMOVE_CONTACT_CATEGORY_SUCCESS:

            return {
                ...state,
                removeContactCategoryPending: false,
                removeContactCategorySuccess: true,

            }

        case Types.REMOVE_CONTACT_CATEGORY_ERROR:

            return {
                ...state,
                removeContactCategoryPending: false,
                removeContactCategoryError: action.payload
            }




        case Types.GET_PHONE_BOOKS_REQUEST:
            return {
                ...state,
                getPhoneBooksPending: true,
                getPhoneBooksSuccess: false,
                getPhoneBooksError: null,
                phoneBooks: {
                    data: [],
                    pageNumber: 0,
                    pageSize: 0,
                    totalCount: null,
                    fillData: function (list: any[]): void {
                        throw new Error("Function not implemented.")
                    }
                }

            }
        case Types.GET_PHONE_BOOKS_SUCCESS:

            return {
                ...state,
                getPhoneBooksPending: false,
                getPhoneBooksSuccess: true,
                phoneBooks: action.response
            }

        case Types.GET_PHONE_BOOKS_ERROR:

            return {
                ...state,
                getPhoneBooksPending: false,
                getPhoneBooksError: action.payload
            }



        case Types.ADD_PHONE_BOOK_REQUEST:
            return {
                ...state,
                addPhoneBookPending: true,
                addPhoneBookSuccess: false,
                addPhoneBookError: null,

            }
        case Types.ADD_PHONE_BOOK_SUCCESS:

            return {
                ...state,
                addPhoneBookPending: false,
                addPhoneBookSuccess: true,

            }

        case Types.ADD_PHONE_BOOK_ERROR:

            return {
                ...state,
                addPhoneBookPending: false,
                addPhoneBookError: action.payload
            }



        case Types.UPDATE_PHONE_BOOK_REQUEST:
            return {
                ...state,
                updatePhoneBookPending: true,
                updatePhoneBookSuccess: false,
                updatePhoneBookError: null,

            }
        case Types.UPDATE_PHONE_BOOK_SUCCESS:

            return {
                ...state,
                updatePhoneBookPending: false,
                updatePhoneBookSuccess: true,

            }

        case Types.UPDATE_PHONE_BOOK_ERROR:

            return {
                ...state,
                updatePhoneBookPending: false,
                updatePhoneBookError: action.payload
            }



        case Types.DELETE_PHONE_BOOK_REQUEST:
            return {
                ...state,
                removePhoneBookPending: true,
                removePhoneBookSuccess: false,
                removePhoneBookError: null,

            }
        case Types.DELETE_PHONE_BOOK_SUCCESS:

            return {
                ...state,
                removePhoneBookPending: false,
                removePhoneBookSuccess: true,

            }

        case Types.DELETE_PHONE_BOOK_ERROR:

            return {
                ...state,
                removePhoneBookPending: false,
                removePhoneBookError: action.payload
            }


        case Types.COPY_BY_PHONEBOOK_REQUEST:
            return {
                ...state,
                copyByPhonebookPending: true,
                copyByPhonebookSuccess: false,
                copyByPhonebookError: null,

            }
        case Types.COPY_BY_PHONEBOOK_SUCCESS:

            return {
                ...state,
                copyByPhonebookPending: false,
                copyByPhonebookSuccess: true,

            }

        case Types.COPY_BY_PHONEBOOK_ERROR:

            return {
                ...state,
                copyByPhonebookPending: false,
                copyByPhonebookError: action.payload
            }


        case Types.MOVE_BY_PHONEBOOK_REQUEST:
            return {
                ...state,
                moveByPhonebookPending: true,
                moveByPhonebookSuccess: false,
                moveByPhonebookError: null,

            }
        case Types.MOVE_BY_PHONEBOOK_SUCCESS:

            return {
                ...state,
                moveByPhonebookPending: false,
                moveByPhonebookSuccess: true,

            }

        case Types.MOVE_BY_PHONEBOOK_ERROR:

            return {
                ...state,
                moveByPhonebookPending: false,
                moveByPhonebookError: action.payload
            }



        case Types.GET_PHONEBOOK_UNPAGED_REQUEST:
            return {
                ...state,
                getUnpagedPhonebookPending: true,
                getUnpagedPhonebookSuccess: false,
                getUnpagedPhonebookError: null,

            }
        case Types.GET_PHONEBOOK_UNPAGED_SUCCESS:

            return {
                ...state,
                getUnpagedPhonebookPending: false,
                getUnpagedPhonebookSuccess: true,
                unpagedPhonebook: action.response

            }

        case Types.GET_PHONEBOOK_UNPAGED_ERROR:

            return {
                ...state,
                getUnpagedPhonebookPending: false,
                getUnpagedPhonebookError: action.payload
            }



        case Types.COPY_BY_CONTACT_REQUEST:
            return {
                ...state,
                copyByContactPending: true,
                copyByContactSuccess: false,
                copyByContactError: null,

            }
        case Types.COPY_BY_CONTACT_SUCCESS:

            return {
                ...state,
                copyByContactPending: false,
                copyByContactSuccess: true,

            }

        case Types.COPY_BY_CONTACT_ERROR:

            return {
                ...state,
                copyByContactPending: false,
                copyByContactError: action.payload
            }


        case Types.MOVE_BY_CONTACT_REQUEST:
            return {
                ...state,
                moveByContactPending: true,
                moveByContactSuccess: false,
                moveByContactError: null,

            }
        case Types.MOVE_BY_CONTACT_SUCCESS:

            return {
                ...state,
                moveByContactPending: false,
                moveByContactSuccess: true,

            }

        case Types.MOVE_BY_CONTACT_ERROR:

            return {
                ...state,
                moveByContactPending: false,
                moveByContactError: action.payload
            }


        case Types.CONTACT_LIST_TO_BLOCK_REQUEST:
            return {
                ...state,
                contactListToBlockPending: true,
                contactListToBlockSuccess: false,
                contactListToBlockError: null,

            }
        case Types.CONTACT_LIST_TO_BLOCK_SUCCESS:

            return {
                ...state,
                contactListToBlockPending: false,
                contactListToBlockSuccess: true,

            }

        case Types.CONTACT_LIST_TO_BLOCK_ERROR:

            return {
                ...state,
                contactListToBlockPending: false,
                contactListToBlockError: action.payload
            }



        case Types.SET_SELECTED_CONTACT_CATEGORY:

            return {
                ...state,
                contactListToBlockPending: false,
                selectedContactCategory: action.payload
            }

        case Types.GET_CONTACT_CALL_DIRECT_REQUEST:
            return {
                ...state,
                getContactCallDirectPending: true,
                getContactCallDirectError: null,

            }
        case Types.GET_CONTACT_CALL_DIRECT_SUCCESS:

            return {
                ...state,
                getContactCallDirectPending: false,
                getContactCallDirectError: null,
                contactsCallDirect: action.response

            }


        case Types.GET_CONTACT_CALL_DIRECT_ERROR:

            return {
                ...state,
                getContactCallDirectPending: false,
                getContactCallDirectError: action.payload
            }
        case Types.GET_CONTACT_CALL_DIRECT_RESET:
            return {
                ...state,
                getContactCallDirectPending: false,
                getContactCallDirectError: null,
                contactsCallDirect: null
            }


        case Types.RESET_CONTACT_PROPS:

            return {
                ...state,
                addContactPending: false,
                addContactSuccess: false,
                updateContactPending: false,
                updateContactSuccess: false,
                removeFromPhoneBookContactPending: false,
                removeFromPhoneBookContactSuccess: false,
                removeContactPending: false,
                removeContactSuccess: false,
                addContactCategoryPending: false,
                addContactCategorySuccess: false,
                updateContactCategoryPending: false,
                updateContactCategorySuccess: false,
                removeContactCategoryPending: false,
                removeContactCategorySuccess: false,
                getPhoneBooksPending: false,
                getPhoneBooksSuccess: false,
                addPhoneBookPending: false,
                addPhoneBookSuccess: false,
                updatePhoneBookPending: false,
                updatePhoneBookSuccess: false,
                removePhoneBookPending: false,
                removePhoneBookSuccess: false,
                copyByPhonebookPending: false,
                copyByPhonebookSuccess: false,
                moveByPhonebookPending: false,
                moveByPhonebookSuccess: false,
                moveByContactPending: false,
                moveByContactSuccess: false,
                copyByContactPending: false,
                copyByContactSuccess: false,
                contactListToBlockPending: false,
                contactListToBlockSuccess: false,
            }




        default:
            return {
                ...state
            }
    }
}

export default contactReducer